import PropTypes from 'prop-types'
import React, { createContext, useState, useEffect, useContext, useMemo } from 'react'

const ThemeContext = createContext()

export const ThemeProvider = ({ children }) => {
  const getPreferredColorScheme = () => {
    // if (window.matchMedia) {
    //   const prefersLightTheme = window.matchMedia('(prefers-color-scheme: light)')
    //   if (prefersLightTheme.matches) {
    //     return 'light'
    //   }
    // }
    return 'dark'
  }

  const getInitialMode = () => {
    const savedMode = localStorage.getItem('theme')
    return savedMode ? savedMode : getPreferredColorScheme()
  }

  const [mode, setMode] = useState(getInitialMode()) // Set initial mode from localStorage

  const switchMode = () => {
    setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'))
  }

  useEffect(() => {
    const body = document.body
    body.classList.toggle('dark-theme', mode === 'dark')
    body.classList.toggle('light-theme', mode === 'light')

    // here we are Saving theme mode to localStorage
    localStorage.setItem('theme', mode)
  }, [mode])

  const value = useMemo(() => ({ mode, switchMode }), [mode])

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

// Custom hook to use theme context
export const useTheme = () => useContext(ThemeContext)
